import { Category } from '~/types/category';
import { Company } from '~/types/company';
import { Money } from '~/types/money';
import { Level } from './budget';

export const CashFlowQueryKeys = {
  all: ['CashFlow'],
  tableByCompany: (companyId: Company['id']) => ['CashFlow', companyId],
  table: (companyId: Company['id'], filter: CashFlowFilter) => [
    'CashFlow',
    companyId,
    'Table',
    { ...filter, accountIds: filter.accountIds.join(',') },
  ],
  outstanding: (companyId: Company['id'], filter: CashFlowFilter) => [
    'CashFlow',
    companyId,
    'Outstanding',
    { ...filter, accountIds: filter.accountIds.join(',') },
  ],
  chart: (companyId: Company['id'], filter: CashFlowFilter) => [
    'CashFlow',
    companyId,
    'Chart',
    { ...filter, accountIds: filter.accountIds.join(',') },
  ],
  chartByCompany: (companyId: Company['id']) => ['CashFlow', companyId, 'Chart'],
};

export interface CashFlowFilter {
  startDate: Date;
  endDate: Date;
  accountIds: string[];
  includeBudgets?: boolean;
  includeOverdue?: boolean;
  includePastdue?: boolean;
}

export interface CashFlowTableRecord {
  is_inflow: boolean;
  categoryId: Category['id'] | null;
  subcategoryId: Category['id'] | null;
  transactionsAmount: Money;
  outstandingAmount: Money;
  pastdueAmount: Money;
  month: number;
  year: number;
  level?: Level;
}

export interface BalanceByMonth {
  balance: {
    start: Money;
    end: Money;
  };
  month: number;
  year: number;
}

export interface CashFlowChartItemFull {
  balance: {
    start: Money;
    end: Money;
  };
  transactions: {
    inflow: Money;
    outflow: Money;
  };
  budgets: {
    inflow: Money;
    outflow: Money;
  };
  outstanding: {
    inflow: Money;
    outflow: Money;
  };
  pastdue: {
    inflow: Money;
    outflow: Money;
  };
  month: number;
  year: number;
}

export type CashflowDataDirection = 'inflow' | 'outflow';

export interface CashFlowTableItemWithBudget {
  id: string;
  budgetId?: string | null;
  budgetAmount: Money | null;
  timePosition: ItemTimePosition;
  amount: Money | null;
  transactionsAmount: Money | null;
  outstandingAmount: Money | null;
  pastdueAmount: Money | null;
  month: number;
  year: number;
  level?: Level;
}

export type ItemTimePosition = 'future' | 'past' | 'current';
